import styled from 'styled-components';

export const Container = styled.label`
  div {
    display: block;
    position: relative;
    cursor: pointer;
    padding-left: 24px;
    margin-bottom: 20px;

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    span {
      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-color: transparent;
      border: 1px solid #d5d5d6;
      border-radius: 100px;
    }

    input:checked ~ span {
      background-color: #004f92;
      border: none;
    }

    span:after {
      content: '';
      position: absolute;
      display: none;
      left: 10px;
      top: 6px;
      width: 3px;
      height: 8px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    input:checked ~ span:after {
      display: block;
    }
  }
`;
